// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ef4b9b8","453":"b0a081e3","732":"b37e74d5"}[chunkId] + ".chunk.js";
};